import { createReducer } from 'reduxsauce';
import { FIELD_REPRESENTATIVES_URL } from 'src/services/api/urls';
import history from 'src/services/browser-history';
import { FRReducerTypes } from '../types';

import Types from './actions-types';

export const INITIAL_STATE: FRReducerTypes = {
  list: [],
  pagination: {
    count: 8,
    total: 8,
    page: 1,
    filter: '',
    s: null,
  },
  isLoading: false,
  hasError: false,
};

export const listRequest = (state = INITIAL_STATE, action: any) => {
  state.list = [];
  return {
    ...state,
    pagination: { ...state.pagination, ...action.filters },
    isLoading: true,
  };
};

export const listRequestSuccess = (state = INITIAL_STATE, action: any) => {
  const { data, ...pagination } = action.data;

  return {
    ...state,
    list: data,
    pagination: { ...state.pagination, ...pagination },
    isLoading: false,
    hasError: false,
  };
};

export const listRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const resetRequest = (state = INITIAL_STATE, action: any) => {
  state.list = [];
  return {
    ...state,
    pagination: { ...state.pagination, ...action.filters },
    isLoading: true,
  };
};

export const resetRequestSuccess = (state = INITIAL_STATE, action: any) => {
  const { password } = action.data.data;

  return {
    ...state,
    password: password,
    isLoading: false,
    hasError: false,
  };
};

export const resetRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const createRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true,
  };
};

export const createRequestSuccess = (state = INITIAL_STATE, action: any) => {
  const list = [...state.list] as any;
  const { fieldRepresentative } = action;

  list.unshift(fieldRepresentative);

  return {
    ...state,
    list,
    isLoading: false,
    hasError: false,
  };
};

export const createRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const deleteRequest = (state = INITIAL_STATE, action: any) => {
  const id = action.id;
  const list = state.list.filter(
    (fr: any) => fr.id.toString() !== id.toString()
  );
  return {
    ...state,
    list,
    isLoading: true,
  };
};

export const deleteRequestSuccess = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: false,
  };
};

export const deleteRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const updateRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true,
    hasError: false,
  };
};

export const updateRequestSuccess = (state = INITIAL_STATE, action: any) => {
  const { fieldRepresentative } = action;
  const list = state.list.map((fr: any) => {
    if (fr.id.toString() === fieldRepresentative.id.toString()) {
      return { ...fr, ...fieldRepresentative };
    }
    return fr;
  });

  return {
    ...state,
    list,
    isLoading: false,
    hasError: false,
  };
};

export const updateRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const getRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true,
  };
};

export const getRequestSuccess = (state = INITIAL_STATE, action: any) => {
  return {
    ...state,
    item: action.data.data,
    isLoading: false,
    hasError: false,
  };
};

export const getRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const clearStore = (state = INITIAL_STATE) => {
  if (
    '/field-representatives/all'.includes(
      history.location.pathname.split('/')[1]
    ) &&
    history.location.search !== ''
  ) {
    return { ...INITIAL_STATE, pagination: state.pagination };
  }
  return INITIAL_STATE;
};

export const HANDLERS = {
  [Types.FIELD_REPRESENTATIVES_LIST_REQUEST as string]: listRequest,
  [Types.FIELD_REPRESENTATIVES_LIST_REQUEST_SUCCESS as string]: listRequestSuccess,
  [Types.FIELD_REPRESENTATIVES_LIST_REQUEST_ERROR as string]: listRequestError,

  [Types.FIELD_REPRESENTATIVES_RESET_REQUEST as string]: resetRequest,
  [Types.FIELD_REPRESENTATIVES_RESET_REQUEST_SUCCESS as string]: resetRequestSuccess,
  [Types.FIELD_REPRESENTATIVES_RESET_REQUEST_ERROR as string]: resetRequestError,

  [Types.FIELD_REPRESENTATIVES_CREATE_REQUEST as string]: createRequest,
  [Types.FIELD_REPRESENTATIVES_CREATE_REQUEST_SUCCESS as string]: createRequestSuccess,
  [Types.FIELD_REPRESENTATIVES_CREATE_REQUEST_ERROR as string]: createRequestError,

  [Types.FIELD_REPRESENTATIVES_DELETE_REQUEST as string]: deleteRequest,
  [Types.FIELD_REPRESENTATIVES_DELETE_REQUEST_SUCCESS as string]: deleteRequestSuccess,
  [Types.FIELD_REPRESENTATIVES_DELETE_REQUEST_ERROR as string]: deleteRequestError,

  [Types.FIELD_REPRESENTATIVES_UPDATE_REQUEST as string]: updateRequest,
  [Types.FIELD_REPRESENTATIVES_UPDATE_REQUEST_SUCCESS as string]: updateRequestSuccess,
  [Types.FIELD_REPRESENTATIVES_UPDATE_REQUEST_ERROR as string]: updateRequestError,

  [Types.FIELD_REPRESENTATIVES_GET_REQUEST as string]: getRequest,
  [Types.FIELD_REPRESENTATIVES_GET_REQUEST_SUCCESS as string]: getRequestSuccess,
  [Types.FIELD_REPRESENTATIVES_GET_REQUEST_ERROR as string]: getRequestError,

  [Types.CLEAR_STORE as string]: clearStore,
};

export default createReducer(INITIAL_STATE, HANDLERS);
